import { useService } from '@policoders/di';
import { useEffect, useState } from 'react';

import { TransactionOptions } from '../../types/transaction.type';
import { CashBook } from './cash-book.model';
import CashBookRepository from './cash-book.repository';

export type ICashBookFormProps = {
  data: CashBook;
  onChange: (data: CashBook) => void;
};

export const useCashBookForm = ({ data, onChange }: ICashBookFormProps) => {
  const [state, setState] = useState<CashBook>(data);
  const repository = useService<CashBookRepository>('CashBookRepository');

  useEffect(() => {
    data.id &&
      repository.getById(data.id).then(value => {
        setState({ ...data, ...value });
      });
  }, [data, repository]);

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const transactionTypes = () => TransactionOptions;

  return { state, transactionTypes, handleChange };
};
